import { useQuery } from '@tanstack/react-query';
import { fetchDashboardStatsData } from '../services/dashboardStatsService';

export function useDashboardStatsData(options = {}) {
  return useQuery({
    queryKey: ['dashboardStatsData'],
    queryFn: async () => {
      const data = await fetchDashboardStatsData();
      return Array.isArray(data?.user_stats) ? data.user_stats : [];
    },
    staleTime: 3 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnMount: options.refetchOnMount ?? true,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: [],
  });
}
